module.exports = __webpack_public_path__ + "img/about_us_icon1.894b894f.png";